<div class="ads-txt">
	
	<cm-topbar *ngIf="isPublisher" title="Ads.txt"></cm-topbar>
	
	<div class="main-content">
		<div class="container">
			<!-- Prikazi samo ima novi ads.txt record - START -->
			<!--<div class="row justify-content-center">-->
			<!--<div class="col-lg-8">-->
			<!--<div class="alert alert-info small" role="alert" >-->
			<!--New records added-->
			<!--<button type="button" (click)="closeReportingPanel()" class="close" data-dismiss="alert">-->
			<!--<span aria-hidden="true">&times;</span>-->
			<!--<span class="sr-only">Close</span>-->
			<!--</button>-->
			<!--</div>-->
			<!--</div>-->
			<!--</div>-->
			<!-- Prikazi samo ima novi ads.txt record - STOP -->
			<div class="row justify-content-center">
				<div class="col-lg-8">
					<mat-card class="example-card">
						<mat-card-content class="p-3">
							<p>
								<strong>Ads.txt (Authorized Digital Sellers)</strong> was launched by the IAB as a simple solution to allow publishers to declare to
								buyers who are officially allowed to sell their inventory.
							</p>
							<p class="">
								Publishers are tired of multiple companies purporting to sell their inventory when they are not allowed - either due
								to fraud or a buyer/exchange reselling the inventory and attempting arbitrage.
							</p>
							<p class="">
								Setting up ads.txt allows publishers to provide a clear message to the market as to who is a true authorized seller
								of their inventory and who is a bad supply source that the publisher doesn’t actually work
								with.
							</p>
							<p class="">
								<strong>Consumable fully supports the initiative</strong> and is requesting our partners to list Consumable’s partners on their
								Ads.txt file when you set it up.
							</p>
						</mat-card-content>
					</mat-card>
					
					<div class="mat-card-control text-center mt-4">
						
						<button mat-raised-button color="primary" class="large iconed" title="ads.txt" (click)="download()">
							<i class="fas fa-download" aria-hidden="true"></i>
							Click here to download ads.txt file
						</button>
					</div>
					
					<p class="mt30 small text-center" *ngIf="lastUpdatedDate">Last updated: <strong>{{lastUpdatedDate}}</strong></p>
				
				</div>
			</div>
		</div>
	</div>
</div>
